module.exports = __webpack_public_path__ + "static/media/nora-full.8414f900.png";